<div class="min-h-screen flex">

  <!-- ══════ Panel izquierdo: Marca (visible solo en lg+) ══════ -->
  <aside class="hidden lg:flex lg:w-[42%] xl:w-2/5 relative overflow-hidden bg-neutral-950 flex-col items-center justify-center">

    <!-- Imagen de fondo -->
    <img
      src="https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?q=80&w=2021&auto=format&fit=crop"
      alt="" aria-hidden="true"
      class="absolute inset-0 w-full h-full object-cover opacity-[0.14]"
    />
    <div class="absolute inset-0 bg-linear-to-b from-neutral-950/70 via-transparent to-neutral-950/80"></div>

    <!-- Contenido de marca -->
    <div class="relative z-10 flex flex-col items-center text-center px-12 max-w-70">

      <!-- Logo -->
      <div class="w-18 h-18 rounded-2xl bg-white/8 border border-white/10 flex items-center justify-center mb-8 backdrop-blur-sm">
        <img ngSrc="/images/app-portal-icon.png" width="82" height="42" [alt]="brandLogoAlt" class="w-10.5 h-auto object-contain" priority />
      </div>

      <h1 class="text-3xl font-bold text-white tracking-tight leading-tight mb-3">
        {{ brandName }}
      </h1>
      <p class="text-neutral-400 text-sm leading-relaxed">
        {{ brandTagline }}
      </p>

      <!-- Decorativo -->
      <div class="flex items-center gap-2 mt-10">
        <span class="w-8 h-px bg-white/15"></span>
        <span class="w-1 h-1 rounded-full bg-white/40"></span>
        <span class="w-8 h-px bg-white/15"></span>
      </div>
    </div>
  </aside>

  <!-- ══════ Panel derecho: Formulario ══════ -->
  <main class="flex-1 flex items-center justify-center p-8 sm:p-12 bg-white dark:bg-neutral-950">
    <div class="w-full max-w-85">

      <!-- Logo compacto (móvil y tablet) -->
      <div class="flex lg:hidden justify-center mb-10">
        <div class="w-12 h-12 max-sm:w-16 max-sm:h-16 rounded-xl max-sm:rounded-2xl bg-neutral-900 flex items-center justify-center">
          <img ngSrc="/images/app-portal-icon.png" width="82" height="42" [alt]="brandLogoAlt" class="w-7 max-sm:w-9 h-auto object-contain" priority />
        </div>
      </div>

      <!-- Cabecera -->
      <div class="mb-7">
        <h2 class="text-xl font-semibold text-neutral-900 dark:text-white tracking-tight">Recuperar contraseña</h2>
        <p class="text-sm text-neutral-500 dark:text-neutral-400 mt-1">Ingresa tu correo electrónico para recibir instrucciones de recuperación</p>
      </div>

      <!-- Formulario -->
      <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()" class="space-y-4">

        <!-- Campo: Email -->
        <div class="flex flex-col gap-1.5">
          <label for="email" class="text-sm font-medium text-neutral-700 dark:text-neutral-300">Correo electrónico</label>
          <p-iconfield class="w-full">
            <p-inputicon class="pi pi-envelope" />
            <input
              pInputText id="email" type="email"
              formControlName="email" autocomplete="email"
              placeholder="tu@correo.com"
              class="w-full"
            />
          </p-iconfield>
          @if (email.invalid && (email.dirty || email.touched)) {
            <small class="text-red-500 text-xs flex items-center gap-1">
              <i class="pi pi-exclamation-circle"></i>
              @if (email.errors?.['required']) { El correo es requerido }
              @else { Ingresa un correo válido }
            </small>
          }
        </div>

        <!-- Botón principal -->
        <div class="pt-1">
          <p-button
            type="submit" label="Enviar instrucciones" icon="pi pi-send" iconPos="right"
            [loading]="isSubmitting()" [disabled]="forgotPasswordForm.invalid"
            [fluid]="true" severity="contrast"
          />
        </div>

        <!-- Volver -->
        <p-button
          type="button" label="Volver al inicio de sesión" icon="pi pi-arrow-left"
          (onClick)="goBack()"
          [fluid]="true" variant="text"
          class="text-neutral-600 hover:text-neutral-900"
        />

      </form>

      <!-- Pie -->
      <p class="text-center text-[11px] text-neutral-400 dark:text-neutral-500 mt-10">
        {{ brandFooterLine }}
      </p>

    </div>
  </main>

</div>
